import React from "react";
import LoadingPost from "./loading/LoadingPost";
const Testj = () => {
  return (
    <div >
      <LoadingPost></LoadingPost>
    </div>
  );
};

export default Testj;
